/**
* Scrolling Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.scrolling-marquee' ).length ) {
        $( '.scrolling-marquee' ).each( function( index, element ) {
          const marqueText = $( element ).find( '.scrolling-marquee__slide-text .marquee-text' );

          let marqueTextWidth = 0;
          marqueText.each( function( index, el ) {
            marqueTextWidth = marqueTextWidth + $( el ).outerWidth();
          } );
          const marqueeSplide = new Splide( $( element )[0], {
            type: 'loop',
            autoWidth: true,
            fixedWidth: `${marqueTextWidth}px`,
            autoScroll: {
              speed: 1,
              pauseOnHover: false,
            },
            arrows: false,
            pagination: false,
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-marquee', COMPONENT );
} )( app );
